import React, { Component } from 'react'
// import Settings from '../settings'
import { TimelineMax } from 'TweenMax'

// This component has:
// 1. Custom image slider
// 2. Each slide has an image and a caption
// 3. Blur animation applied to slider content

import IconSquare from './icons/IconSquare'

class SectionImageSlider extends Component {

   constructor() {
     super()
     this.state = {
       slide: 0,
       count: 6,
       play: 0
     }
   }

   componentDidMount() {
      this.setState({ count: this.props.data.gallery.length })
      // Settings.animation.on && Settings.animation.blur_images && this.animateBlur()

      // this.play()
   }

   animateBlur = () => {
      // console.log('should hover');
     const el = '.slider-content' // '.slider-image-blur'
    //  new TimelineMax({ repeat: -1, repeatDelay: 6, timeScale: 1.5 })
     new TimelineMax({ timeScale: 1.5 })
     .to(el, 0.1, { filter: "blur(1px)" })
     .to(el, 0.1, { filter: "blur(0px)" })
     .to(el, 0.1, { filter: "blur(0px)" })
     .to(el, 0.1, { filter: "blur(2px)" })
     .to(el, 0.1, { filter: "blur(4px)" })
     .to(el, 0.1, { filter: "blur(1px)" })
     .to(el, 0.1, { filter: "blur(3px)" })
     .to(el, 0.1, { filter: "blur(1px)" })
     .to(el, 0.1, { filter: "blur(0px)" })
   }

   next = (e, speed = 3000) => {
      e && e.preventDefault()
      this.timer && clearTimeout(this.timer)

      const next_slide = (this.state.slide===this.state.count-1) ? 0 : this.state.slide+1
      // console.log('next', next_slide);
      this.setState({ slide: next_slide })

      if (this.state.play) {
        this.timer = setTimeout(this.next,speed)
      }
   }

   prev = (e) => {
      e && e.preventDefault()

      const prev_slide = (this.state.slide===0) ? this.state.count-1 : this.state.slide-1
      // console.log('prev', prev_slide);
      this.setState({ slide: prev_slide })
   }

   play = (speed = 3000) => {
      this.setState({play: 1})
      this.next()
   }

   stop = () => {
      this.setState({play: 0})
      this.timer && clearTimeout(this.timer)
   }

   renderSlide = (slide, i) => {
      const {
        caption = 'Still from Hiroshima Mon Amour by Alain Resnais',
        // url = 'https://source.unsplash.com/random/800x500&new='+i,
        sizes,
      } = slide

      const url_small = sizes['large']
      // console.log(slide);

      // const caption = 'Still from Hiroshima Mon Amour by Alain Resnais'
      const ref = 'slide-'+i
      const activeClass = (i===this.state.slide || this.state.count===1) ? 'slide-active' : 'slide-inactive'
      const style = {
         backgroundImage:`url(${url_small})`
      }

      return (
         <div key={i} className={`slider-slide ${ref} ${activeClass}`}>
           <div className="slider-image-blur">
            <div className="slider-image" onMouseEnter={this.animateBlur()} onClick={this.next}>
               <div className="slider-image-feather feather-rect"></div>
               <div className="slider-image-background" style={style}></div>
               {/* <img width="800px" height="500px" src="" alt=""/> */}
               {/* <img src={sizes['tdn-medium']} alt=""/> */}
            </div>
            </div>
            {caption && <div className="slider-caption"><IconSquare size="10px"/>&nbsp;&nbsp;&nbsp;{caption}&nbsp;&nbsp;&nbsp;<IconSquare size="10px"/></div>}
         </div>
      )
   }

   render() {
      const { gallery } = this.props.data
      const singularClass = (this.state.count===1) ? 'slider-single' : ''

      return (
         <div className="SectionImageSlider">

            <div className={`slider-wrapper ${singularClass}`}>

               <div className="slider-left left" onClick={this.prev}><div>
                  <svg viewBox="0 0 41 169" className="slider-arrow-bounds">
                      <title>arrow-previous</title>
                      <g id="arrow-prev-group" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="arrow-previous" className="slider-arrow" stroke="#fff">
                              <polyline id="arrow_prev" points="40 168.859 0 84.644 40 0.429"></polyline>
                          </g>
                      </g>
                  </svg>
               </div></div>

               <div className="slider-content">
                  { gallery.map((slide, i) => this.renderSlide(slide, i)) }
               </div>

               <div className="slider-right right" onClick={this.next}><div>
                  <svg viewBox="0 0 41 169" className="slider-arrow-bounds">
                      <title>arrow-next</title>
                      <g id="arrow-next-group" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="arrow-next" className="slider-arrow" stroke="#fff">
                              <polyline id="arrow_next" transform="translate(20.502600, 84.429500) scale(-1, 1) translate(-20.502600, -84.429500) " points="40 168.859 0 84.644 40 0.429"></polyline>
                          </g>
                      </g>
                  </svg>
               </div></div>

            </div>

         </div>
      )
   }
}

export default SectionImageSlider



// WEBPACK FOOTER //
// ./src/components/SectionImageSlider.js